module.exports = __webpack_public_path__ + "static/media/Koryu No Mimi - English v2.0.b602bc75.zip";


//////////////////
// WEBPACK FOOTER
// ./src/files/Koryu No Mimi - English v2.0.zip
// module id = 71
// module chunks = 0